import "./IllustratorContainer.css";
const IllustratorContainer = (props) => {
  return <div className="illustrator">{props.children}</div>;
};

export default IllustratorContainer;
